import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'INVIT_CLIENT',
  title: 'Wie kann ich meinen Kunden Zugang zu meinem Ordner geben?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Zunächst einmal muss Ihr Kunde kein Mitglied der Plattform sein, um Zugang zur Plattform zu haben. Um ihnen Zugang zu Ihrem Ordner zu gewähren, müssen Sie sie nur suchen und nach dem untenstehenden Schema einladen.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte "Kunden"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf die blaue Schaltfläche "Kunde hinzufügen" oben rechts auf dem Bildschirm.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Suchen Sie in der Suchleiste nach "Ihr Kunde".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Erscheint Ihr Kunde in der Liste? Ein einfacher Klick darauf fügt ihn zu Ihrer Kundenliste hinzu.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Ihr Kunde erscheint nicht in der Liste? Klicken Sie auf "Firma "NAME" in mein Netzwerk einladen " '
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Geben Sie anschließend die gewünschten Informationen ein.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_CLIENT/DE_INVIT_CLIENT_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Bestätigen!'
  }]
};
